import * as React from 'react';
import { Container, Navbar as N } from 'reactstrap';
import './Navbar.css';

const style = {
    Boxes: {
        height: 'auto',
        maxWidth: 140,
        width: '100%',
    },
    HungFookTongLogo: {
        height: 60,
        margin: '8px 0',
        padding: 4,
        width: 'auto',
    },
    ShippingFormButton: {
        height: 'auto',
        marginTop: 10,
        width: 250,
        zIndex: 99,
    }
};

export interface INavBarProps {
    name: string;
    image_path: string;
    url: string;
    logo: any;
    boxes: string;
    banner: string;
    banner_header: string;
    deliveryeform: any;
    colors: any;
}

export const Navbar = (props: INavBarProps) => (
    <N style={{ padding: 0 }}>
        <Container className='d-flex align-items-start' style={{ maxWidth: '100%', padding: 0 }}>
            <img src={props.image_path + props.boxes} style={style.Boxes} className='Boxes' />
            <div className='align-self-start' style={{ padding: '8px 16px' }}>
                <div className='align-self-start'>
                    <a href={props.logo.hft.url} target='_blank'>
                        <img src={props.image_path + props.logo.hft.image} style={style.HungFookTongLogo} title={props.logo.hft.title} className='HungFookTongLogo' />
                    </a>
                    <img src={props.image_path + props.logo.separator} style={style.HungFookTongLogo} className='HungFookTongLogo' />
                    <a href={props.logo.jika.url} target='_blank'>
                        <img src={props.image_path + props.logo.jika.image} style={style.HungFookTongLogo} title={props.logo.jika.title} className='HungFookTongLogo' />
                    </a>
                </div>
                <div className='d-flex justify-content-center align-items-start'>
                    <a href={props.deliveryeform.url} target='_blank' style={{textDecoration: 'none'}}>
                        <div className='ShippingFormButton'>{props.deliveryeform.name}</div>
                        {/* <img src={props.image_path + props.deliveryeform.button} title={props.deliveryeform.name} style={style.ShippingFormButton} className='ShippingFormButton' /> */}
                    </a>
                </div>
            </div>
        </Container>
        <Container className='d-flex justify-content-center Banner' style={{ marginTop: -30 }}>
            <img src={props.image_path + props.banner} style={{ width: '100%', maxWidth: 1300, position: 'relative', zIndex: -1 }} />
        </Container>
        <Container className='d-flex justify-content-end BannerTitle' style={{ maxWidth: '100%', padding: 0, marginTop: -30 }}>
            <img src={props.image_path + props.banner_header} style={{ width: '100%', maxWidth: 300 }} />
        </Container>
    </N>
);


// WEBPACK FOOTER //
// ./src/pages/Home/Navbar/index.tsx